<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Container Stuffing</li>
                </ol>
                <h4 class="main-title mb-0">Container Stuffing</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header">
                    <h6 class="card-title">Container Stuffing</h6>
                </div>
                    <div class="card-body">
                        <div class="row g-2">
                            <div class="col-md-4">
                                <label class="form-label">From Date</label><span class="text-danger"> *</span>
                                <input type="date" class="form-control" :class="{ 'is-invalid': errors?.from_date }" :max="today" v-model="report.from_date" />
                                <span v-if="errors?.from_date"><small class="text-danger">{{ errors?.from_date[0] }}</small></span>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label">To Date</label><span class="text-danger"> *</span>
                                <input type="date" class="form-control" :class="{ 'is-invalid': errors?.to_date }" :max="today" v-model="report.to_date" />
                                <span v-if="errors?.to_date"><small class="text-danger">{{ errors?.to_date[0] }}</small></span>
                            </div>
                            <div class="col-md-4">
                                <div style="float:right">
                                    <button type="button" class="btn btn-primary" style="margin-top:2em;margin-right:1em" @click="getContainerStuffing()"><i class="ri-save-line fs-18 lh-1"></i> Get</button>
                                    <button type="button" class="btn btn-secondary" style="margin-top:2em" @click="downloadContainerStuffing()"><i class="ri-download-line fs-18 lh-1"></i> Download</button>
                                </div>
                            </div>
                        </div>
                        <div class="row g-2 mt-2">
                            <div class="col-md-12">
                                <div class="table-responsive table-responsive-sm">
                                    <table class="table table-bordered table-striped table-sm">
                                        <thead class="sticky-header">
                                            <tr style="background-color:#9b9b9b;color:white;">
                                                <th class="text-center" width="1%">#</th>
                                                <th class="text-center" width="7%">Date</th>
                                                <th class="text-center" width="8%">Trailer No</th>
                                                <th class="text-center" width="10%">Container No</th>
                                                <th class="text-center" width="10%">WO No Customer</th>
                                                <th class="text-center" width="5%">Grade</th>
                                                <th class="text-center" width="5%">Packing</th>
                                                <th class="text-center" width="5%">Lot No</th>
                                                <th class="text-center" width="5%">Quantity</th>
                                                <th class="text-center" width="5%">Bags</th>
                                                <th class="text-center" width="5%">Pallet Size</th>
                                                <th class="text-center" width="5%">Same Day</th>
                                                <th class="text-center" width="7%">DOD</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="trips.length==0">
                                            <tr>
                                                <td colspan="13" class="text-center">No records found</td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr v-for="trip, key in trips" :key="key">
                                                <td>{{ key+1 }}</td>
                                                <td class="text-center">{{ convertDateFormat(trip.trip_date_time) }}</td>
                                                <td>{{ trip.wagon_no }}</td>
                                                <td>{{ trip.container_no }}</td>
                                                <td>{{ trip.work_order_no }}<br>{{ trip.customer_name}}</td>
                                                <td>{{ trip.product_name }}</td>
                                                <td>{{ trip.packing_name }}</td>
                                                <td class="text-center">{{ trip.lot_no }}</td>
                                                <td class="text-center">{{ trip.loading_quantity }}</td>
                                                <td class="text-center">{{ trip.loading_bags }}</td>
                                                <td class="text-center">{{ trip.pallet_size_name }}</td>
                                                <td class="text-center">{{ trip.same_date_loaded }}</td>
                                                <td class="text-center">{{ convertDateFormat(trip.date_of_dispatch) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
export default {
    data(){
        return{
            report:{
                from_date:'',
                to_date:'',
                excel:false
            },
            today:'',
            errors:[],
            trips:[]
        }
    },
    mounted(){
        this.today = moment().format('yyyy-MM-DD')
        this.report.to_date = moment().format('yyyy-MM-DD')
    },
    methods:{
        convertDateFormat(date){
            if(date){
                return moment(date).format('DD-MM-yyyy hh:mm a')
            }else{
                return null
            }
        },
        downloadContainerStuffing(){
            window.open(this.$store.getters.apiUrl+'downloadContainerStuffing?from_date='+this.report.from_date+'&to_date='+this.report.to_date)
        },
        getContainerStuffing(){
            let vm = this;
            vm.$store
                .dispatch("post", { uri: "getContainerStuffing", data: vm.report })
                .then((response) => {
                    vm.trips = response.data
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.trips = []
                    vm.$store.dispatch("error", error.response.data.message);
                });
        }
    }
}
</script>
<style scoped>
.table-responsive {
    height: 400px; 
    overflow-y: auto; 
}

.sticky-header th {
    position: sticky;
    top: 0;
    z-index: 10; 
    background-color: #9b9b9b; 
    color: white;
}

</style>